import { ReportOrderList } from "../../components/reportOrderList";
import {
  useGetIdentity,
} from "@pankod/refine-core";

export const DashboardPage: React.FC = () => {
  const { data: user } = useGetIdentity();
  // console.log('------------');
  // console.log(user.user_metadata);
  // if (user.user_metadata.role === "agent") {
  //   return (
  //     <div>403 Forbiden</div>
  //   )
  // }
  return (
    <>
      <ReportOrderList />
    </>
  );
};
